import { BaseColorsType, SizesType } from '../../@types/theme/theme-types';

export const baseColorsDefault: BaseColorsType = {
	neutral: {
		'100': '#FDFDFD',
		'200': '#E0E0E0',
		'300': '#B4B4B4',
		'400': '#7B7B7B',
		'500': '',
		'600': '#606060',
		'700': '#333333',
		'800': '#222222',
		'900': '#171717',
		'950': '#121212',
	},
	green: {
		'100': '#D1FFD1',
		'200': '#D1FFD1',
		'300': '#7EF28B',
		'400': '#42D758',
		'500': '#00C318',
		'600': '#238124',
		'700': '',
		'800': '#1A5B1A',
		'900': '#152B14',
		'950': '#101910',
	},
	blue: {
		'100': '#E5F4FF',
		'200': '#CBE4FD',
		'300': '#A3D1FF',
		'400': '#62A4F3',
		'500': '#0C8BEA',
		'600': '#164E7F',
		'700': '',
		'800': '#07406E',
		'900': '#0B2842',
		'950': '#0D1822',
	},
	red: {
		'100': '#F8B4B4',
		'200': '#E37D7D',
		'300': '#FF6C6C',
		'400': '#BB3A3A',
		'500': '',
		'600': '',
		'700': '',
		'800': '#932525',
		'900': '#711313',
		'950': '',
	},
};

export const sizesDefault: SizesType = {
	px: 1,
	'px-plus': 2,
	xs: 4,
	'xs-plus': 6,
	sm: 8,
	'sm-plus': 10,
	'sm-x': 12,
	md: 16,
	'md-plus': 20,
	lg: 24,
	xl: 32,
	'2xl': 40,
	'3xl': 48,
	'4xl': 56,
	'5xl': 64,
	'6xl': 72,
	'7xl': 96,
};
